/**
 * Toggles a 'is-sticky' class for the page header when the user has scrolled down the page.
 */

const initStickyHeader = () => {
    const pageHeader = document.getElementById('js_sticky-header');
    const pageHeaderTrigger = document.getElementById('js_sticky-header-trigger');

    const IntersectionObserverCallback = (entries) => {
        const stickyClass = 'is-sticky';

        entries.forEach(entry => {
            if (entry.boundingClientRect.y < 0 && !entry.isIntersecting) {
                pageHeader.classList.add(stickyClass);
            } else {
                pageHeader.classList.remove(stickyClass);
            }
        });
    };

    if (pageHeader && pageHeaderTrigger
        && 'IntersectionObserver' in window
        && 'IntersectionObserverEntry' in window
        && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

        const observer = new IntersectionObserver(IntersectionObserverCallback, {
            threshold: 0
        });

        observer.observe(pageHeaderTrigger);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initStickyHeader();
});
